import React from 'react';
import { useLocation } from 'react-router-dom';
import { t } from '@lingui/macro';

import { Box, Button, Heading, Paragraph } from '@rover/kibble/core';
import { buildAuthUrl } from '@rover/utilities/buildAuthUrl';

import { SEARCH_BY_NAME_OPEN_PARAM } from '../constants';

const SearchByNameLoginRequiredScreen = (): JSX.Element => {
  const location = useLocation();

  const handleLogin = (): void => {
    const params = new URLSearchParams(location.search);
    params.set(SEARCH_BY_NAME_OPEN_PARAM, 'true');
    const next = `${location.pathname}?${params.toString()}${location.hash}`;
    // /account/continue/ is a server-rendered page, so SPA routing can't reach it.
    // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
    window.location.href = buildAuthUrl({ next, action: 'sign_in' });
  };

  return (
    <Box p="4x" testID="search-by-name-login-required">
      <Heading size="300" mb="2x">
        {t`Log in to search by name`}
      </Heading>
      <Paragraph size="200" mb="6x">
        {t`For sitter safety, you need to be logged in to search for a specific sitter by name.`}
      </Paragraph>
      <Button variant="primary" fullWidth onClick={handleLogin} testID="login-button">
        {t`Log in`}
      </Button>
    </Box>
  );
};

export default SearchByNameLoginRequiredScreen;
